import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-item-detalle-carrito',
	templateUrl: './item-detalle-carrito.component.html',
	styleUrls: ['./item-detalle-carrito.component.css']
})
export class ItemDetalleCarritoComponent implements OnInit {

	@Input() newProducto:any;
	@Input() newDivisa:any;
	@Input() newTipo:number;

	constructor() { }

	ngOnInit() {
	}

	fnGetImage(){
		if( this.newProducto.fotografia ){
			return this.newProducto.fotografia.base64;
		}else{
			return "assets/images/sinFotografia.png";
		}
	}

}
